import { render, staticRenderFns } from "./BAsyncInput.vue?vue&type=template&id=51bc5d43&scoped=true"
import script from "./BAsyncInput.vue?vue&type=script&lang=js"
export * from "./BAsyncInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51bc5d43",
  null
  
)

export default component.exports